import { SortOrder } from '../sort-order';

export class EntityMeasurementFilters {
  sortField?: string;
  sortOrder?: SortOrder;
  name?: string;
  measurementTypeUnits?: string[];
}
